module.exports = __webpack_public_path__ + "static/img/s19.5257bad2.png";